/**
 * MCP OAuth Provider
 *
 * OAuth client provider implementation for the Model Context Protocol (MCP)
 */

export { MCPOAuthClientProvider } from './client/index.js';

export {
  createStorageAdapter,
  FileStorage,
  MemoryStorage,
  OAuthStorage,
  type StorageAdapter,
} from './client/storage.js';

export {
  DEFAULT_CLIENT_METADATA,
  generateSessionId,
  generateState,
  type OAuthClientInformation,
  type OAuthClientInformationFull,
  type OAuthClientMetadata,
  type OAuthConfig,
  type OAuthTokens,
} from './client/config.js';

/**
 * Factory function to create an OAuth client provider
 */
export { createOAuthProvider } from './client/factory.js';
